// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UeberUnsRouteImport } from './routes/ueber-uns'
import { Route as LighthouseCheckRouteImport } from './routes/lighthouse-check'
import { Route as LeistungenRouteImport } from './routes/leistungen'
import { Route as KontaktRouteImport } from './routes/kontakt'
import { Route as ImpressumRouteImport } from './routes/impressum'
import { Route as EnRouteImport } from './routes/en'
import { Route as DatenschutzerklaerungRouteImport } from './routes/datenschutzerklaerung'
import { Route as BarrierefreiheitRouteImport } from './routes/barrierefreiheit'
import { Route as AdwordsAgenturRouteImport } from './routes/adwords-agentur'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ToolsIndexRouteImport } from './routes/tools.index'
import { Route as RegionenIndexRouteImport } from './routes/regionen.index'
import { Route as GlossarIndexRouteImport } from './routes/glossar.index'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as ToolsWirtschaftlichkeitsrechnerRouteImport } from './routes/tools.wirtschaftlichkeitsrechner'
import { Route as ToolsPerformanceMarketingChecklisteRouteImport } from './routes/tools.performance-marketing-checkliste'
import { Route as ToolsLighthouseCheckRouteImport } from './routes/tools.lighthouse-check'
import { Route as RegionenWuerzburgRouteImport } from './routes/regionen.wuerzburg'
import { Route as RegionenSchweinfurtRouteImport } from './routes/regionen.schweinfurt'
import { Route as RegionenNuernbergRouteImport } from './routes/regionen.nuernberg'
import { Route as RegionenFrankfurtRouteImport } from './routes/regionen.frankfurt'
import { Route as RegionenAschaffenburgRouteImport } from './routes/regionen.aschaffenburg'
import { Route as GlossarSlugRouteImport } from './routes/glossar.$slug'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as LeistungenIndexRouteImport } from './routes/leistungen.index'
import { Route as LeistungenWebsiteEntwicklungRouteImport } from './routes/leistungen.website-entwicklung'
import { Route as LeistungenTrackingDatenbasisRouteImport } from './routes/leistungen.tracking-datenbasis'
import { Route as LeistungenToolsRouteImport } from './routes/leistungen.tools'
import { Route as LeistungenStrategieKoordinationRouteImport } from './routes/leistungen.strategie-koordination'
import { Route as LeistungenSocialMediaMarketingRouteImport } from './routes/leistungen.social-media-marketing'
import { Route as LeistungenShopEntwicklungRouteImport } from './routes/leistungen.shop-entwicklung'
import { Route as LeistungenSeoAiSeoRouteImport } from './routes/leistungen.seo-ai-seo'
import { Route as LeistungenPicazzooRouteImport } from './routes/leistungen.picazzoo'
import { Route as LeistungenPerformanceMarketingRouteImport } from './routes/leistungen.performance-marketing'
import { Route as LeistungenOnlineshopEntwicklungRouteImport } from './routes/leistungen.onlineshop-entwicklung'
import { Route as LeistungenGonzaladsRouteImport } from './routes/leistungen.gonzalads'
import { Route as LeistungenGeoGenerativeEngineOptimizationRouteImport } from './routes/leistungen.geo-generative-engine-optimization'
import { Route as LeistungenEntwicklungDigitalerDiensteRouteImport } from './routes/leistungen.entwicklung-digitaler-dienste'
import { Route as LeistungenDeltaRouteImport } from './routes/leistungen.delta'
import { Route as LeistungenConversionWebOptimierungRouteImport } from './routes/leistungen.conversion-web-optimierung'
import { Route as LeistungenConversionRateOptimierungRouteImport } from './routes/leistungen.conversion-rate-optimierung'
import { Route as EnIndexRouteImport } from './routes/en.index'
import { Route as EnServicesRouteImport } from './routes/en.services'
import { Route as EnPrivacyPolicyRouteImport } from './routes/en.privacy-policy'
import { Route as EnLighthouseCheckRouteImport } from './routes/en.lighthouse-check'
import { Route as EnImprintRouteImport } from './routes/en.imprint'
import { Route as EnContactRouteImport } from './routes/en.contact'
import { Route as EnAccessibilityRouteImport } from './routes/en.accessibility'
import { Route as EnAboutRouteImport } from './routes/en.about'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminSettingsRouteImport } from './routes/admin.settings'
import { Route as AdminRedirectsRouteImport } from './routes/admin.redirects'
import { Route as AdminLoginRouteImport } from './routes/admin.login'
import { Route as AdminAnalyticsRouteImport } from './routes/admin.analytics'
import { Route as RegionenWuerzburgSeoAgenturRouteImport } from './routes/regionen.wuerzburg_.seo-agentur'
import { Route as LeistungenOnlineshopEntwicklungShopifyAgenturRouteImport } from './routes/leistungen.onlineshop-entwicklung_.shopify-agentur'
import { Route as LeistungenPerformanceMarketingIndexRouteImport } from './routes/leistungen.performance-marketing.index'
import { Route as LeistungenPerformanceMarketingYoutubeDemandGenRouteImport } from './routes/leistungen.performance-marketing.youtube-demand-gen'
import { Route as LeistungenPerformanceMarketingTiktokAdsRouteImport } from './routes/leistungen.performance-marketing.tiktok-ads'
import { Route as LeistungenPerformanceMarketingSocialMediaWerbungRouteImport } from './routes/leistungen.performance-marketing.social-media-werbung'
import { Route as LeistungenPerformanceMarketingMicrosoftAdsRouteImport } from './routes/leistungen.performance-marketing.microsoft-ads'
import { Route as LeistungenPerformanceMarketingMetaAdsRouteImport } from './routes/leistungen.performance-marketing.meta-ads'
import { Route as LeistungenPerformanceMarketingLinkedinAdsRouteImport } from './routes/leistungen.performance-marketing.linkedin-ads'
import { Route as LeistungenPerformanceMarketingGoogleAdsRouteImport } from './routes/leistungen.performance-marketing.google-ads'
import { Route as LeistungenPerformanceMarketingAffiliateMarketingRouteImport } from './routes/leistungen.performance-marketing.affiliate-marketing'
import { Route as EnToolsIndexRouteImport } from './routes/en.tools.index'
import { Route as EnRegionsIndexRouteImport } from './routes/en.regions.index'
import { Route as EnGlossaryIndexRouteImport } from './routes/en.glossary.index'
import { Route as EnBlogIndexRouteImport } from './routes/en.blog.index'
import { Route as EnToolsProfitabilityCalculatorRouteImport } from './routes/en.tools.profitability-calculator'
import { Route as EnToolsPerformanceMarketingChecklistRouteImport } from './routes/en.tools.performance-marketing-checklist'
import { Route as EnToolsLighthouseCheckRouteImport } from './routes/en.tools.lighthouse-check'
import { Route as EnRegionsWuerzburgRouteImport } from './routes/en.regions.wuerzburg'
import { Route as EnRegionsSchweinfurtRouteImport } from './routes/en.regions.schweinfurt'
import { Route as EnRegionsNuernbergRouteImport } from './routes/en.regions.nuernberg'
import { Route as EnRegionsFrankfurtRouteImport } from './routes/en.regions.frankfurt'
import { Route as EnRegionsAschaffenburgRouteImport } from './routes/en.regions.aschaffenburg'
import { Route as EnGlossarySlugRouteImport } from './routes/en.glossary.$slug'
import { Route as EnBlogSlugRouteImport } from './routes/en.blog.$slug'
import { Route as EnServicesIndexRouteImport } from './routes/en.services.index'
import { Route as EnServicesWebsiteDevelopmentRouteImport } from './routes/en.services.website-development'
import { Route as EnServicesTrackingDataFoundationRouteImport } from './routes/en.services.tracking-data-foundation'
import { Route as EnServicesToolsRouteImport } from './routes/en.services.tools'
import { Route as EnServicesStrategicCoordinationRouteImport } from './routes/en.services.strategic-coordination'
import { Route as EnServicesSocialMediaMarketingRouteImport } from './routes/en.services.social-media-marketing'
import { Route as EnServicesShopDevelopmentRouteImport } from './routes/en.services.shop-development'
import { Route as EnServicesSeoAiSeoRouteImport } from './routes/en.services.seo-ai-seo'
import { Route as EnServicesPicazzooRouteImport } from './routes/en.services.picazzoo'
import { Route as EnServicesPerformanceMarketingRouteImport } from './routes/en.services.performance-marketing'
import { Route as EnServicesGonzaladsRouteImport } from './routes/en.services.gonzalads'
import { Route as EnServicesGeoGenerativeEngineOptimizationRouteImport } from './routes/en.services.geo-generative-engine-optimization'
import { Route as EnServicesEcommerceDevelopmentRouteImport } from './routes/en.services.ecommerce-development'
import { Route as EnServicesDigitalDevelopmentRouteImport } from './routes/en.services.digital-development'
import { Route as EnServicesDeltaRouteImport } from './routes/en.services.delta'
import { Route as EnServicesConversionRateOptimizationRouteImport } from './routes/en.services.conversion-rate-optimization'
import { Route as EnServicesConversionOptimizationRouteImport } from './routes/en.services.conversion-optimization'
import { Route as LeistungenPerformanceMarketingMetaAdsIndexRouteImport } from './routes/leistungen.performance-marketing.meta-ads.index'
import { Route as LeistungenPerformanceMarketingMetaAdsRecruitingRouteImport } from './routes/leistungen.performance-marketing.meta-ads.recruiting'
import { Route as EnServicesEcommerceDevelopmentShopifyAgencyRouteImport } from './routes/en.services.ecommerce-development_.shopify-agency'
import { Route as EnServicesPerformanceMarketingIndexRouteImport } from './routes/en.services.performance-marketing.index'
import { Route as EnServicesPerformanceMarketingYoutubeDemandGenRouteImport } from './routes/en.services.performance-marketing.youtube-demand-gen'
import { Route as EnServicesPerformanceMarketingTiktokAdsRouteImport } from './routes/en.services.performance-marketing.tiktok-ads'
import { Route as EnServicesPerformanceMarketingSocialMediaAdvertisingRouteImport } from './routes/en.services.performance-marketing.social-media-advertising'
import { Route as EnServicesPerformanceMarketingMicrosoftAdsRouteImport } from './routes/en.services.performance-marketing.microsoft-ads'
import { Route as EnServicesPerformanceMarketingMetaAdsRouteImport } from './routes/en.services.performance-marketing.meta-ads'
import { Route as EnServicesPerformanceMarketingLinkedinAdsRouteImport } from './routes/en.services.performance-marketing.linkedin-ads'
import { Route as EnServicesPerformanceMarketingGoogleAdsRouteImport } from './routes/en.services.performance-marketing.google-ads'
import { Route as EnServicesPerformanceMarketingAffiliateMarketingRouteImport } from './routes/en.services.performance-marketing.affiliate-marketing'
import { Route as EnServicesPerformanceMarketingMetaAdsIndexRouteImport } from './routes/en.services.performance-marketing.meta-ads.index'
import { Route as EnServicesPerformanceMarketingMetaAdsRecruitingRouteImport } from './routes/en.services.performance-marketing.meta-ads.recruiting'

const UeberUnsRoute = UeberUnsRouteImport.update({
            id: '/ueber-uns',path: '/ueber-uns',getParentRoute: () => rootRouteImport
          })
const LighthouseCheckRoute = LighthouseCheckRouteImport.update({
            id: '/lighthouse-check',path: '/lighthouse-check',getParentRoute: () => rootRouteImport
          })
const LeistungenRoute = LeistungenRouteImport.update({
            id: '/leistungen',path: '/leistungen',getParentRoute: () => rootRouteImport
          })
const KontaktRoute = KontaktRouteImport.update({
            id: '/kontakt',path: '/kontakt',getParentRoute: () => rootRouteImport
          })
const ImpressumRoute = ImpressumRouteImport.update({
            id: '/impressum',path: '/impressum',getParentRoute: () => rootRouteImport
          })
const EnRoute = EnRouteImport.update({
            id: '/en',path: '/en',getParentRoute: () => rootRouteImport
          })
const DatenschutzerklaerungRoute = DatenschutzerklaerungRouteImport.update({
            id: '/datenschutzerklaerung',path: '/datenschutzerklaerung',getParentRoute: () => rootRouteImport
          })
const BarrierefreiheitRoute = BarrierefreiheitRouteImport.update({
            id: '/barrierefreiheit',path: '/barrierefreiheit',getParentRoute: () => rootRouteImport
          })
const AdwordsAgenturRoute = AdwordsAgenturRouteImport.update({
            id: '/adwords-agentur',path: '/adwords-agentur',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/admin.lazy').then((d) => d.Route))
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ToolsIndexRoute = ToolsIndexRouteImport.update({
            id: '/tools/',path: '/tools/',getParentRoute: () => rootRouteImport
          })
const RegionenIndexRoute = RegionenIndexRouteImport.update({
            id: '/regionen/',path: '/regionen/',getParentRoute: () => rootRouteImport
          })
const GlossarIndexRoute = GlossarIndexRouteImport.update({
            id: '/glossar/',path: '/glossar/',getParentRoute: () => rootRouteImport
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const ToolsWirtschaftlichkeitsrechnerRoute = ToolsWirtschaftlichkeitsrechnerRouteImport.update({
            id: '/tools/wirtschaftlichkeitsrechner',path: '/tools/wirtschaftlichkeitsrechner',getParentRoute: () => rootRouteImport
          })
const ToolsPerformanceMarketingChecklisteRoute = ToolsPerformanceMarketingChecklisteRouteImport.update({
            id: '/tools/performance-marketing-checkliste',path: '/tools/performance-marketing-checkliste',getParentRoute: () => rootRouteImport
          })
const ToolsLighthouseCheckRoute = ToolsLighthouseCheckRouteImport.update({
            id: '/tools/lighthouse-check',path: '/tools/lighthouse-check',getParentRoute: () => rootRouteImport
          })
const RegionenWuerzburgRoute = RegionenWuerzburgRouteImport.update({
            id: '/regionen/wuerzburg',path: '/regionen/wuerzburg',getParentRoute: () => rootRouteImport
          })
const RegionenSchweinfurtRoute = RegionenSchweinfurtRouteImport.update({
            id: '/regionen/schweinfurt',path: '/regionen/schweinfurt',getParentRoute: () => rootRouteImport
          })
const RegionenNuernbergRoute = RegionenNuernbergRouteImport.update({
            id: '/regionen/nuernberg',path: '/regionen/nuernberg',getParentRoute: () => rootRouteImport
          })
const RegionenFrankfurtRoute = RegionenFrankfurtRouteImport.update({
            id: '/regionen/frankfurt',path: '/regionen/frankfurt',getParentRoute: () => rootRouteImport
          })
const RegionenAschaffenburgRoute = RegionenAschaffenburgRouteImport.update({
            id: '/regionen/aschaffenburg',path: '/regionen/aschaffenburg',getParentRoute: () => rootRouteImport
          })
const GlossarSlugRoute = GlossarSlugRouteImport.update({
            id: '/glossar/$slug',path: '/glossar/$slug',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const LeistungenIndexRoute = LeistungenIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LeistungenRoute
          })
const LeistungenWebsiteEntwicklungRoute = LeistungenWebsiteEntwicklungRouteImport.update({
            id: '/website-entwicklung',path: '/website-entwicklung',getParentRoute: () => LeistungenRoute
          })
const LeistungenTrackingDatenbasisRoute = LeistungenTrackingDatenbasisRouteImport.update({
            id: '/tracking-datenbasis',path: '/tracking-datenbasis',getParentRoute: () => LeistungenRoute
          })
const LeistungenToolsRoute = LeistungenToolsRouteImport.update({
            id: '/tools',path: '/tools',getParentRoute: () => LeistungenRoute
          })
const LeistungenStrategieKoordinationRoute = LeistungenStrategieKoordinationRouteImport.update({
            id: '/strategie-koordination',path: '/strategie-koordination',getParentRoute: () => LeistungenRoute
          })
const LeistungenSocialMediaMarketingRoute = LeistungenSocialMediaMarketingRouteImport.update({
            id: '/social-media-marketing',path: '/social-media-marketing',getParentRoute: () => LeistungenRoute
          })
const LeistungenShopEntwicklungRoute = LeistungenShopEntwicklungRouteImport.update({
            id: '/shop-entwicklung',path: '/shop-entwicklung',getParentRoute: () => LeistungenRoute
          })
const LeistungenSeoAiSeoRoute = LeistungenSeoAiSeoRouteImport.update({
            id: '/seo-ai-seo',path: '/seo-ai-seo',getParentRoute: () => LeistungenRoute
          })
const LeistungenPicazzooRoute = LeistungenPicazzooRouteImport.update({
            id: '/picazzoo',path: '/picazzoo',getParentRoute: () => LeistungenRoute
          })
const LeistungenPerformanceMarketingRoute = LeistungenPerformanceMarketingRouteImport.update({
            id: '/performance-marketing',path: '/performance-marketing',getParentRoute: () => LeistungenRoute
          })
const LeistungenOnlineshopEntwicklungRoute = LeistungenOnlineshopEntwicklungRouteImport.update({
            id: '/onlineshop-entwicklung',path: '/onlineshop-entwicklung',getParentRoute: () => LeistungenRoute
          })
const LeistungenGonzaladsRoute = LeistungenGonzaladsRouteImport.update({
            id: '/gonzalads',path: '/gonzalads',getParentRoute: () => LeistungenRoute
          })
const LeistungenGeoGenerativeEngineOptimizationRoute = LeistungenGeoGenerativeEngineOptimizationRouteImport.update({
            id: '/geo-generative-engine-optimization',path: '/geo-generative-engine-optimization',getParentRoute: () => LeistungenRoute
          })
const LeistungenEntwicklungDigitalerDiensteRoute = LeistungenEntwicklungDigitalerDiensteRouteImport.update({
            id: '/entwicklung-digitaler-dienste',path: '/entwicklung-digitaler-dienste',getParentRoute: () => LeistungenRoute
          })
const LeistungenDeltaRoute = LeistungenDeltaRouteImport.update({
            id: '/delta',path: '/delta',getParentRoute: () => LeistungenRoute
          })
const LeistungenConversionWebOptimierungRoute = LeistungenConversionWebOptimierungRouteImport.update({
            id: '/conversion-web-optimierung',path: '/conversion-web-optimierung',getParentRoute: () => LeistungenRoute
          })
const LeistungenConversionRateOptimierungRoute = LeistungenConversionRateOptimierungRouteImport.update({
            id: '/conversion-rate-optimierung',path: '/conversion-rate-optimierung',getParentRoute: () => LeistungenRoute
          })
const EnIndexRoute = EnIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => EnRoute
          })
const EnServicesRoute = EnServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => EnRoute
          })
const EnPrivacyPolicyRoute = EnPrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => EnRoute
          })
const EnLighthouseCheckRoute = EnLighthouseCheckRouteImport.update({
            id: '/lighthouse-check',path: '/lighthouse-check',getParentRoute: () => EnRoute
          })
const EnImprintRoute = EnImprintRouteImport.update({
            id: '/imprint',path: '/imprint',getParentRoute: () => EnRoute
          })
const EnContactRoute = EnContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => EnRoute
          })
const EnAccessibilityRoute = EnAccessibilityRouteImport.update({
            id: '/accessibility',path: '/accessibility',getParentRoute: () => EnRoute
          })
const EnAboutRoute = EnAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => EnRoute
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminSettingsRoute = AdminSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AdminRoute
          })
const AdminRedirectsRoute = AdminRedirectsRouteImport.update({
            id: '/redirects',path: '/redirects',getParentRoute: () => AdminRoute
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => AdminRoute
          }).lazy(() => import('./routes/admin.login.lazy').then((d) => d.Route))
const AdminAnalyticsRoute = AdminAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AdminRoute
          })
const RegionenWuerzburgSeoAgenturRoute = RegionenWuerzburgSeoAgenturRouteImport.update({
            id: '/regionen/wuerzburg_/seo-agentur',path: '/regionen/wuerzburg/seo-agentur',getParentRoute: () => rootRouteImport
          })
const LeistungenOnlineshopEntwicklungShopifyAgenturRoute = LeistungenOnlineshopEntwicklungShopifyAgenturRouteImport.update({
            id: '/onlineshop-entwicklung_/shopify-agentur',path: '/onlineshop-entwicklung/shopify-agentur',getParentRoute: () => LeistungenRoute
          })
const LeistungenPerformanceMarketingIndexRoute = LeistungenPerformanceMarketingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LeistungenPerformanceMarketingRoute
          })
const LeistungenPerformanceMarketingYoutubeDemandGenRoute = LeistungenPerformanceMarketingYoutubeDemandGenRouteImport.update({
            id: '/youtube-demand-gen',path: '/youtube-demand-gen',getParentRoute: () => LeistungenPerformanceMarketingRoute
          })
const LeistungenPerformanceMarketingTiktokAdsRoute = LeistungenPerformanceMarketingTiktokAdsRouteImport.update({
            id: '/tiktok-ads',path: '/tiktok-ads',getParentRoute: () => LeistungenPerformanceMarketingRoute
          })
const LeistungenPerformanceMarketingSocialMediaWerbungRoute = LeistungenPerformanceMarketingSocialMediaWerbungRouteImport.update({
            id: '/social-media-werbung',path: '/social-media-werbung',getParentRoute: () => LeistungenPerformanceMarketingRoute
          })
const LeistungenPerformanceMarketingMicrosoftAdsRoute = LeistungenPerformanceMarketingMicrosoftAdsRouteImport.update({
            id: '/microsoft-ads',path: '/microsoft-ads',getParentRoute: () => LeistungenPerformanceMarketingRoute
          })
const LeistungenPerformanceMarketingMetaAdsRoute = LeistungenPerformanceMarketingMetaAdsRouteImport.update({
            id: '/meta-ads',path: '/meta-ads',getParentRoute: () => LeistungenPerformanceMarketingRoute
          })
const LeistungenPerformanceMarketingLinkedinAdsRoute = LeistungenPerformanceMarketingLinkedinAdsRouteImport.update({
            id: '/linkedin-ads',path: '/linkedin-ads',getParentRoute: () => LeistungenPerformanceMarketingRoute
          })
const LeistungenPerformanceMarketingGoogleAdsRoute = LeistungenPerformanceMarketingGoogleAdsRouteImport.update({
            id: '/google-ads',path: '/google-ads',getParentRoute: () => LeistungenPerformanceMarketingRoute
          })
const LeistungenPerformanceMarketingAffiliateMarketingRoute = LeistungenPerformanceMarketingAffiliateMarketingRouteImport.update({
            id: '/affiliate-marketing',path: '/affiliate-marketing',getParentRoute: () => LeistungenPerformanceMarketingRoute
          })
const EnToolsIndexRoute = EnToolsIndexRouteImport.update({
            id: '/tools/',path: '/tools/',getParentRoute: () => EnRoute
          })
const EnRegionsIndexRoute = EnRegionsIndexRouteImport.update({
            id: '/regions/',path: '/regions/',getParentRoute: () => EnRoute
          })
const EnGlossaryIndexRoute = EnGlossaryIndexRouteImport.update({
            id: '/glossary/',path: '/glossary/',getParentRoute: () => EnRoute
          })
const EnBlogIndexRoute = EnBlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => EnRoute
          })
const EnToolsProfitabilityCalculatorRoute = EnToolsProfitabilityCalculatorRouteImport.update({
            id: '/tools/profitability-calculator',path: '/tools/profitability-calculator',getParentRoute: () => EnRoute
          })
const EnToolsPerformanceMarketingChecklistRoute = EnToolsPerformanceMarketingChecklistRouteImport.update({
            id: '/tools/performance-marketing-checklist',path: '/tools/performance-marketing-checklist',getParentRoute: () => EnRoute
          })
const EnToolsLighthouseCheckRoute = EnToolsLighthouseCheckRouteImport.update({
            id: '/tools/lighthouse-check',path: '/tools/lighthouse-check',getParentRoute: () => EnRoute
          })
const EnRegionsWuerzburgRoute = EnRegionsWuerzburgRouteImport.update({
            id: '/regions/wuerzburg',path: '/regions/wuerzburg',getParentRoute: () => EnRoute
          })
const EnRegionsSchweinfurtRoute = EnRegionsSchweinfurtRouteImport.update({
            id: '/regions/schweinfurt',path: '/regions/schweinfurt',getParentRoute: () => EnRoute
          })
const EnRegionsNuernbergRoute = EnRegionsNuernbergRouteImport.update({
            id: '/regions/nuernberg',path: '/regions/nuernberg',getParentRoute: () => EnRoute
          })
const EnRegionsFrankfurtRoute = EnRegionsFrankfurtRouteImport.update({
            id: '/regions/frankfurt',path: '/regions/frankfurt',getParentRoute: () => EnRoute
          })
const EnRegionsAschaffenburgRoute = EnRegionsAschaffenburgRouteImport.update({
            id: '/regions/aschaffenburg',path: '/regions/aschaffenburg',getParentRoute: () => EnRoute
          })
const EnGlossarySlugRoute = EnGlossarySlugRouteImport.update({
            id: '/glossary/$slug',path: '/glossary/$slug',getParentRoute: () => EnRoute
          })
const EnBlogSlugRoute = EnBlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => EnRoute
          })
const EnServicesIndexRoute = EnServicesIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => EnServicesRoute
          })
const EnServicesWebsiteDevelopmentRoute = EnServicesWebsiteDevelopmentRouteImport.update({
            id: '/website-development',path: '/website-development',getParentRoute: () => EnServicesRoute
          })
const EnServicesTrackingDataFoundationRoute = EnServicesTrackingDataFoundationRouteImport.update({
            id: '/tracking-data-foundation',path: '/tracking-data-foundation',getParentRoute: () => EnServicesRoute
          })
const EnServicesToolsRoute = EnServicesToolsRouteImport.update({
            id: '/tools',path: '/tools',getParentRoute: () => EnServicesRoute
          })
const EnServicesStrategicCoordinationRoute = EnServicesStrategicCoordinationRouteImport.update({
            id: '/strategic-coordination',path: '/strategic-coordination',getParentRoute: () => EnServicesRoute
          })
const EnServicesSocialMediaMarketingRoute = EnServicesSocialMediaMarketingRouteImport.update({
            id: '/social-media-marketing',path: '/social-media-marketing',getParentRoute: () => EnServicesRoute
          })
const EnServicesShopDevelopmentRoute = EnServicesShopDevelopmentRouteImport.update({
            id: '/shop-development',path: '/shop-development',getParentRoute: () => EnServicesRoute
          })
const EnServicesSeoAiSeoRoute = EnServicesSeoAiSeoRouteImport.update({
            id: '/seo-ai-seo',path: '/seo-ai-seo',getParentRoute: () => EnServicesRoute
          })
const EnServicesPicazzooRoute = EnServicesPicazzooRouteImport.update({
            id: '/picazzoo',path: '/picazzoo',getParentRoute: () => EnServicesRoute
          })
const EnServicesPerformanceMarketingRoute = EnServicesPerformanceMarketingRouteImport.update({
            id: '/performance-marketing',path: '/performance-marketing',getParentRoute: () => EnServicesRoute
          })
const EnServicesGonzaladsRoute = EnServicesGonzaladsRouteImport.update({
            id: '/gonzalads',path: '/gonzalads',getParentRoute: () => EnServicesRoute
          })
const EnServicesGeoGenerativeEngineOptimizationRoute = EnServicesGeoGenerativeEngineOptimizationRouteImport.update({
            id: '/geo-generative-engine-optimization',path: '/geo-generative-engine-optimization',getParentRoute: () => EnServicesRoute
          })
const EnServicesEcommerceDevelopmentRoute = EnServicesEcommerceDevelopmentRouteImport.update({
            id: '/ecommerce-development',path: '/ecommerce-development',getParentRoute: () => EnServicesRoute
          })
const EnServicesDigitalDevelopmentRoute = EnServicesDigitalDevelopmentRouteImport.update({
            id: '/digital-development',path: '/digital-development',getParentRoute: () => EnServicesRoute
          })
const EnServicesDeltaRoute = EnServicesDeltaRouteImport.update({
            id: '/delta',path: '/delta',getParentRoute: () => EnServicesRoute
          })
const EnServicesConversionRateOptimizationRoute = EnServicesConversionRateOptimizationRouteImport.update({
            id: '/conversion-rate-optimization',path: '/conversion-rate-optimization',getParentRoute: () => EnServicesRoute
          })
const EnServicesConversionOptimizationRoute = EnServicesConversionOptimizationRouteImport.update({
            id: '/conversion-optimization',path: '/conversion-optimization',getParentRoute: () => EnServicesRoute
          })
const LeistungenPerformanceMarketingMetaAdsIndexRoute = LeistungenPerformanceMarketingMetaAdsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LeistungenPerformanceMarketingMetaAdsRoute
          })
const LeistungenPerformanceMarketingMetaAdsRecruitingRoute = LeistungenPerformanceMarketingMetaAdsRecruitingRouteImport.update({
            id: '/recruiting',path: '/recruiting',getParentRoute: () => LeistungenPerformanceMarketingMetaAdsRoute
          })
const EnServicesEcommerceDevelopmentShopifyAgencyRoute = EnServicesEcommerceDevelopmentShopifyAgencyRouteImport.update({
            id: '/ecommerce-development_/shopify-agency',path: '/ecommerce-development/shopify-agency',getParentRoute: () => EnServicesRoute
          })
const EnServicesPerformanceMarketingIndexRoute = EnServicesPerformanceMarketingIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => EnServicesPerformanceMarketingRoute
          })
const EnServicesPerformanceMarketingYoutubeDemandGenRoute = EnServicesPerformanceMarketingYoutubeDemandGenRouteImport.update({
            id: '/youtube-demand-gen',path: '/youtube-demand-gen',getParentRoute: () => EnServicesPerformanceMarketingRoute
          })
const EnServicesPerformanceMarketingTiktokAdsRoute = EnServicesPerformanceMarketingTiktokAdsRouteImport.update({
            id: '/tiktok-ads',path: '/tiktok-ads',getParentRoute: () => EnServicesPerformanceMarketingRoute
          })
const EnServicesPerformanceMarketingSocialMediaAdvertisingRoute = EnServicesPerformanceMarketingSocialMediaAdvertisingRouteImport.update({
            id: '/social-media-advertising',path: '/social-media-advertising',getParentRoute: () => EnServicesPerformanceMarketingRoute
          })
const EnServicesPerformanceMarketingMicrosoftAdsRoute = EnServicesPerformanceMarketingMicrosoftAdsRouteImport.update({
            id: '/microsoft-ads',path: '/microsoft-ads',getParentRoute: () => EnServicesPerformanceMarketingRoute
          })
const EnServicesPerformanceMarketingMetaAdsRoute = EnServicesPerformanceMarketingMetaAdsRouteImport.update({
            id: '/meta-ads',path: '/meta-ads',getParentRoute: () => EnServicesPerformanceMarketingRoute
          })
const EnServicesPerformanceMarketingLinkedinAdsRoute = EnServicesPerformanceMarketingLinkedinAdsRouteImport.update({
            id: '/linkedin-ads',path: '/linkedin-ads',getParentRoute: () => EnServicesPerformanceMarketingRoute
          })
const EnServicesPerformanceMarketingGoogleAdsRoute = EnServicesPerformanceMarketingGoogleAdsRouteImport.update({
            id: '/google-ads',path: '/google-ads',getParentRoute: () => EnServicesPerformanceMarketingRoute
          })
const EnServicesPerformanceMarketingAffiliateMarketingRoute = EnServicesPerformanceMarketingAffiliateMarketingRouteImport.update({
            id: '/affiliate-marketing',path: '/affiliate-marketing',getParentRoute: () => EnServicesPerformanceMarketingRoute
          })
const EnServicesPerformanceMarketingMetaAdsIndexRoute = EnServicesPerformanceMarketingMetaAdsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => EnServicesPerformanceMarketingMetaAdsRoute
          })
const EnServicesPerformanceMarketingMetaAdsRecruitingRoute = EnServicesPerformanceMarketingMetaAdsRecruitingRouteImport.update({
            id: '/recruiting',path: '/recruiting',getParentRoute: () => EnServicesPerformanceMarketingMetaAdsRoute
          })





const AdminRouteChildren = {
  AdminAnalyticsRoute: AdminAnalyticsRoute,AdminLoginRoute: AdminLoginRoute,AdminRedirectsRoute: AdminRedirectsRoute,AdminSettingsRoute: AdminSettingsRoute,AdminIndexRoute: AdminIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const EnServicesPerformanceMarketingMetaAdsRouteChildren = {
  EnServicesPerformanceMarketingMetaAdsRecruitingRoute: EnServicesPerformanceMarketingMetaAdsRecruitingRoute,EnServicesPerformanceMarketingMetaAdsIndexRoute: EnServicesPerformanceMarketingMetaAdsIndexRoute
}

const EnServicesPerformanceMarketingMetaAdsRouteWithChildren = EnServicesPerformanceMarketingMetaAdsRoute._addFileChildren(EnServicesPerformanceMarketingMetaAdsRouteChildren)



const EnServicesPerformanceMarketingRouteChildren = {
  EnServicesPerformanceMarketingAffiliateMarketingRoute: EnServicesPerformanceMarketingAffiliateMarketingRoute,EnServicesPerformanceMarketingGoogleAdsRoute: EnServicesPerformanceMarketingGoogleAdsRoute,EnServicesPerformanceMarketingLinkedinAdsRoute: EnServicesPerformanceMarketingLinkedinAdsRoute,EnServicesPerformanceMarketingMetaAdsRoute: EnServicesPerformanceMarketingMetaAdsRouteWithChildren,EnServicesPerformanceMarketingMicrosoftAdsRoute: EnServicesPerformanceMarketingMicrosoftAdsRoute,EnServicesPerformanceMarketingSocialMediaAdvertisingRoute: EnServicesPerformanceMarketingSocialMediaAdvertisingRoute,EnServicesPerformanceMarketingTiktokAdsRoute: EnServicesPerformanceMarketingTiktokAdsRoute,EnServicesPerformanceMarketingYoutubeDemandGenRoute: EnServicesPerformanceMarketingYoutubeDemandGenRoute,EnServicesPerformanceMarketingIndexRoute: EnServicesPerformanceMarketingIndexRoute
}

const EnServicesPerformanceMarketingRouteWithChildren = EnServicesPerformanceMarketingRoute._addFileChildren(EnServicesPerformanceMarketingRouteChildren)



const EnServicesRouteChildren = {
  EnServicesConversionOptimizationRoute: EnServicesConversionOptimizationRoute,EnServicesConversionRateOptimizationRoute: EnServicesConversionRateOptimizationRoute,EnServicesDeltaRoute: EnServicesDeltaRoute,EnServicesDigitalDevelopmentRoute: EnServicesDigitalDevelopmentRoute,EnServicesEcommerceDevelopmentRoute: EnServicesEcommerceDevelopmentRoute,EnServicesGeoGenerativeEngineOptimizationRoute: EnServicesGeoGenerativeEngineOptimizationRoute,EnServicesGonzaladsRoute: EnServicesGonzaladsRoute,EnServicesPerformanceMarketingRoute: EnServicesPerformanceMarketingRouteWithChildren,EnServicesPicazzooRoute: EnServicesPicazzooRoute,EnServicesSeoAiSeoRoute: EnServicesSeoAiSeoRoute,EnServicesShopDevelopmentRoute: EnServicesShopDevelopmentRoute,EnServicesSocialMediaMarketingRoute: EnServicesSocialMediaMarketingRoute,EnServicesStrategicCoordinationRoute: EnServicesStrategicCoordinationRoute,EnServicesToolsRoute: EnServicesToolsRoute,EnServicesTrackingDataFoundationRoute: EnServicesTrackingDataFoundationRoute,EnServicesWebsiteDevelopmentRoute: EnServicesWebsiteDevelopmentRoute,EnServicesIndexRoute: EnServicesIndexRoute,EnServicesEcommerceDevelopmentShopifyAgencyRoute: EnServicesEcommerceDevelopmentShopifyAgencyRoute
}

const EnServicesRouteWithChildren = EnServicesRoute._addFileChildren(EnServicesRouteChildren)



const EnRouteChildren = {
  EnAboutRoute: EnAboutRoute,EnAccessibilityRoute: EnAccessibilityRoute,EnContactRoute: EnContactRoute,EnImprintRoute: EnImprintRoute,EnLighthouseCheckRoute: EnLighthouseCheckRoute,EnPrivacyPolicyRoute: EnPrivacyPolicyRoute,EnServicesRoute: EnServicesRouteWithChildren,EnIndexRoute: EnIndexRoute,EnBlogSlugRoute: EnBlogSlugRoute,EnGlossarySlugRoute: EnGlossarySlugRoute,EnRegionsAschaffenburgRoute: EnRegionsAschaffenburgRoute,EnRegionsFrankfurtRoute: EnRegionsFrankfurtRoute,EnRegionsNuernbergRoute: EnRegionsNuernbergRoute,EnRegionsSchweinfurtRoute: EnRegionsSchweinfurtRoute,EnRegionsWuerzburgRoute: EnRegionsWuerzburgRoute,EnToolsLighthouseCheckRoute: EnToolsLighthouseCheckRoute,EnToolsPerformanceMarketingChecklistRoute: EnToolsPerformanceMarketingChecklistRoute,EnToolsProfitabilityCalculatorRoute: EnToolsProfitabilityCalculatorRoute,EnBlogIndexRoute: EnBlogIndexRoute,EnGlossaryIndexRoute: EnGlossaryIndexRoute,EnRegionsIndexRoute: EnRegionsIndexRoute,EnToolsIndexRoute: EnToolsIndexRoute
}

const EnRouteWithChildren = EnRoute._addFileChildren(EnRouteChildren)




const LeistungenPerformanceMarketingMetaAdsRouteChildren = {
  LeistungenPerformanceMarketingMetaAdsRecruitingRoute: LeistungenPerformanceMarketingMetaAdsRecruitingRoute,LeistungenPerformanceMarketingMetaAdsIndexRoute: LeistungenPerformanceMarketingMetaAdsIndexRoute
}

const LeistungenPerformanceMarketingMetaAdsRouteWithChildren = LeistungenPerformanceMarketingMetaAdsRoute._addFileChildren(LeistungenPerformanceMarketingMetaAdsRouteChildren)



const LeistungenPerformanceMarketingRouteChildren = {
  LeistungenPerformanceMarketingAffiliateMarketingRoute: LeistungenPerformanceMarketingAffiliateMarketingRoute,LeistungenPerformanceMarketingGoogleAdsRoute: LeistungenPerformanceMarketingGoogleAdsRoute,LeistungenPerformanceMarketingLinkedinAdsRoute: LeistungenPerformanceMarketingLinkedinAdsRoute,LeistungenPerformanceMarketingMetaAdsRoute: LeistungenPerformanceMarketingMetaAdsRouteWithChildren,LeistungenPerformanceMarketingMicrosoftAdsRoute: LeistungenPerformanceMarketingMicrosoftAdsRoute,LeistungenPerformanceMarketingSocialMediaWerbungRoute: LeistungenPerformanceMarketingSocialMediaWerbungRoute,LeistungenPerformanceMarketingTiktokAdsRoute: LeistungenPerformanceMarketingTiktokAdsRoute,LeistungenPerformanceMarketingYoutubeDemandGenRoute: LeistungenPerformanceMarketingYoutubeDemandGenRoute,LeistungenPerformanceMarketingIndexRoute: LeistungenPerformanceMarketingIndexRoute
}

const LeistungenPerformanceMarketingRouteWithChildren = LeistungenPerformanceMarketingRoute._addFileChildren(LeistungenPerformanceMarketingRouteChildren)



const LeistungenRouteChildren = {
  LeistungenConversionRateOptimierungRoute: LeistungenConversionRateOptimierungRoute,LeistungenConversionWebOptimierungRoute: LeistungenConversionWebOptimierungRoute,LeistungenDeltaRoute: LeistungenDeltaRoute,LeistungenEntwicklungDigitalerDiensteRoute: LeistungenEntwicklungDigitalerDiensteRoute,LeistungenGeoGenerativeEngineOptimizationRoute: LeistungenGeoGenerativeEngineOptimizationRoute,LeistungenGonzaladsRoute: LeistungenGonzaladsRoute,LeistungenOnlineshopEntwicklungRoute: LeistungenOnlineshopEntwicklungRoute,LeistungenPerformanceMarketingRoute: LeistungenPerformanceMarketingRouteWithChildren,LeistungenPicazzooRoute: LeistungenPicazzooRoute,LeistungenSeoAiSeoRoute: LeistungenSeoAiSeoRoute,LeistungenShopEntwicklungRoute: LeistungenShopEntwicklungRoute,LeistungenSocialMediaMarketingRoute: LeistungenSocialMediaMarketingRoute,LeistungenStrategieKoordinationRoute: LeistungenStrategieKoordinationRoute,LeistungenToolsRoute: LeistungenToolsRoute,LeistungenTrackingDatenbasisRoute: LeistungenTrackingDatenbasisRoute,LeistungenWebsiteEntwicklungRoute: LeistungenWebsiteEntwicklungRoute,LeistungenIndexRoute: LeistungenIndexRoute,LeistungenOnlineshopEntwicklungShopifyAgenturRoute: LeistungenOnlineshopEntwicklungShopifyAgenturRoute
}

const LeistungenRouteWithChildren = LeistungenRoute._addFileChildren(LeistungenRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRouteWithChildren,AdwordsAgenturRoute: AdwordsAgenturRoute,BarrierefreiheitRoute: BarrierefreiheitRoute,DatenschutzerklaerungRoute: DatenschutzerklaerungRoute,EnRoute: EnRouteWithChildren,ImpressumRoute: ImpressumRoute,KontaktRoute: KontaktRoute,LeistungenRoute: LeistungenRouteWithChildren,LighthouseCheckRoute: LighthouseCheckRoute,UeberUnsRoute: UeberUnsRoute,BlogSlugRoute: BlogSlugRoute,GlossarSlugRoute: GlossarSlugRoute,RegionenAschaffenburgRoute: RegionenAschaffenburgRoute,RegionenFrankfurtRoute: RegionenFrankfurtRoute,RegionenNuernbergRoute: RegionenNuernbergRoute,RegionenSchweinfurtRoute: RegionenSchweinfurtRoute,RegionenWuerzburgRoute: RegionenWuerzburgRoute,ToolsLighthouseCheckRoute: ToolsLighthouseCheckRoute,ToolsPerformanceMarketingChecklisteRoute: ToolsPerformanceMarketingChecklisteRoute,ToolsWirtschaftlichkeitsrechnerRoute: ToolsWirtschaftlichkeitsrechnerRoute,BlogIndexRoute: BlogIndexRoute,GlossarIndexRoute: GlossarIndexRoute,RegionenIndexRoute: RegionenIndexRoute,ToolsIndexRoute: ToolsIndexRoute,RegionenWuerzburgSeoAgenturRoute: RegionenWuerzburgSeoAgenturRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)